import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'

import { makeStyles } from '@material-ui/core/styles'

import Autocomplete from '@material-ui/lab/Autocomplete'
import Chip from '@material-ui/core/Chip'

import { connect } from 'react-redux'
import {
  loadProgrammesData,
  updateCsvAction,
  loadRolesData,
  updateSetupProgress,
  updateSummeryUserEmailList
} from '../../actions'

import Tooltip from '@material-ui/core/Tooltip'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'

import BrowserStore from 'store'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

class PaymentForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isRoleSelected: [],
      items: [],
      value: '',
      error: null,
      inseadCanvasAdmin: BrowserStore.get('inseadCanvasAdmin')
    }
  }

  handleKeyDown = (evt) => {
    if (['Enter', 'Tab', ','].includes(evt.key)) {
      evt.preventDefault()

      var value = this.state.value.trim()

      if (value && this.isValid(value)) {
        this.setState({
          items: [...this.state.items, this.state.value],
          value: ''
        })

        this.props.updateSummeryUserEmailList(
          [...this.state.items, this.state.value].join(',')
        )
      }
    }
  }

  handleRadioChange = (event) => {
    let value = event.target.value

    this.props.updateCsvAction(value)
  }

  handleChange = (evt) => {
    this.setState({
      value: evt.target.value,
      error: null
    })
  }

  handleBlur = (evt) => {
    // this.setState({
    //   value: evt.target.value,
    //   error: null
    // });

    var emails = evt.target.value.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g)

    if (emails) {
      var toBeAdded = emails.filter((email) => !this.isInList(email))

      this.setState({
        items: [...this.state.items, ...toBeAdded]
      })

      this.props.updateSummeryUserEmailList(
        [...this.state.items, ...toBeAdded].join(',')
      )
    }
  }

  handleDelete = (item) => {
    this.setState({
      items: this.state.items.filter((i) => i !== item)
    })

    this.props.updateSummeryUserEmailList(
      this.state.items.filter((i) => i !== item).join(',')
    )
  }

  handlePaste = (evt) => {
    evt.preventDefault()

    var paste = evt.clipboardData.getData('text')
    var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g)

    if (emails) {
      var toBeAdded = emails.filter((email) => !this.isInList(email))

      this.setState({
        items: [...this.state.items, ...toBeAdded]
      })

      this.props.updateSummeryUserEmailList(
        [...this.state.items, ...toBeAdded].join(',')
      )
    }
  }

  isValid(email) {
    let error = null

    if (this.isInList(email)) {
      error = `${email} has already been added.`
    }

    if (!this.isEmail(email)) {
      error = `${email} is not a valid email address.`
    }

    if (error) {
      this.setState({ error })

      return false
    }

    return true
  }

  isInList(email) {
    return this.state.items.includes(email)
  }

  isEmail(email) {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email)
  }

  componentDidMount() {
    if (this.props.data.roles.data.length == 0) {
      this.props.loadRolesData()
    }

    let data = this.props.data.summery.userstext
      .split(',')
      .filter((d) => d != '')

    if (data.length != 0) {
      this.setState({
        items: [...data]
      })
    }
  }

  render() {
    let selectedRoleValue
    const { data } = this.props
    let roles = [[{ id: 0, label: 'Loading..' }]]

    let name = ''

    let includeRoles = []

    if (this.state.inseadCanvasAdmin.sub_account.perm === 'CUSTOM') {
      includeRoles = this.state.inseadCanvasAdmin.sub_account.roles.split(',')
    } else {
      includeRoles = process.env.REACT_APP_ENABLE_ROLES.split(',')
    }

    const radioDefaultValue = data.csvActionType

    if (typeof data.roles !== 'undefined') {
      roles = data.roles.data
    }

    const setRoleClick = (event) => {
      for (var i = 0; i < this.props.data.summery.data.length; i++) {
        if (this.props.data.summery.data[i].value === 'role') {
          this.props.data.summery.data.splice(i, 1)
        }
      }

      if (event !== null) {
        this.props.data.summery.data.push({
          id: event.id,
          name: event.label,
          title: event.role,
          value: 'role',
          label: event.label
        })
      }

      this.selectedRoleValue = event
      this.setState({
        isRoleSelected: data.summery.data.filter((data) => data.value == 'role')
      })
      this.props.updateSummeryUserEmailList([...this.state.items].join(','))
    }

    const handleChangeText = (event) => {
      this.props.data.summery.userstext = this.state.items.join(',')
    }

    let inputValueRole = data.summery.data.filter(
      (data) => data.value == 'role'
    )

    if (inputValueRole.length != 0) {
      inputValueRole = inputValueRole[0]
    }

    roles = roles.filter((rows) => includeRoles.includes(rows.id.toString()))

    const optionsRoles = roles.map((option) => {
      const firstLetter = option.label[0].toUpperCase()

      return {
        firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
        ...option
      }
    })

    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Autocomplete
              id='combo-box-3'
              noOptionsText='Loading..'
              options={optionsRoles.sort(
                (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
              )}
              getOptionLabel={(option) => option.label}
              style={{ width: 300 }}
              onChange={(event, newValue) => {
                setRoleClick(newValue)
              }}
              defaultValue={inputValueRole}
              renderInput={(params) => (
                <TextField {...params} label='Roles' variant='outlined' />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormLabel component='legend'>Action</FormLabel>
            <RadioGroup
              row
              aria-label='action'
              name='action'
              value={radioDefaultValue}
              onChange={this.handleRadioChange}
            >
              <FormControlLabel
                value='active'
                control={<Radio />}
                label='Add'
              />
              <FormControlLabel
                value='deleted'
                control={<Radio />}
                label='Remove'
              />
            </RadioGroup>
          </Grid>

          <Grid item xs={12} md={12}>
            <Tooltip placement='top' title='Press Enter to add users.' arrow>
              <TextField
                fullWidth
                error={this.state.error}
                id='outlined-multiline-static'
                label='Type email address and Press Enter to add users.'
                multiline
                rows='12'
                variant='outlined'
                value={this.state.value}
                onKeyDown={this.handleKeyDown}
                onChange={this.handleChange}
                onPaste={this.handlePaste}
                onBlur={this.handleBlur}
                helperText='When adding multiple users, use a comma or line break to separate users.              '
              />
            </Tooltip>
          </Grid>

          {this.state.error && <p className='error'>{this.state.error}</p>}

          {this.props.data.summery.userstext
            .split(',')
            .map((item) =>
              item.length ? (
                <Chip
                  label={item}
                  key={item}
                  onDelete={() => this.handleDelete(item)}
                  style={{ margin: '4px' }}
                />
              ) : (
                ''
              )
            )}
        </Grid>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.CourseLevelAdmin
  }
}

export default connect(mapStateToProps, {
  loadProgrammesData,
  loadRolesData,
  updateCsvAction,
  updateSetupProgress,
  updateSummeryUserEmailList
})(PaymentForm)
